// extracted by mini-css-extract-plugin
module.exports = {"container":"End_container__3ydZV","anim":"End_anim__13V87","message":"End_message__x9Lwv","connect":"End_connect__2_as0"};